export const initialState = {
  header: { approvalTypeLevelId: null, approvalTypeId: null, siteId: null, changed: false },
  approvalTypeEmployees: [],
  approvalTypeUserGroups: [],
  deletedItems: {
    approvalTypeEmployees: [],
    approvalTypeUserGroups: []
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'setDefaultUserGroup':
      return setDefaultUserGroup(state, action);
    case 'setDefaultEmployee':
      return setDefaultEmployee(state, action);
    case 'onPropertyChanged':
      return onPropertyChanged(state, action);
    case 'onAddApprovalTypeEmployee':
      return onAddApprovalTypeEmployee(state, action);
    case 'onAddApprovalTypeUserGroup':
      return onAddApprovalTypeUserGroup(state, action);
    case 'onDeleteItemCollection':
      return onDeleteItemCollection(state, action);
    case 'onApprovalTypeLevelAdded':
      return onApprovalTypeLevelAdded(state, action);
    case 'OnApprovalTypeLevelSaved':
      return onApprovalTypeLevelSaved(state, action);
    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { approvalTypeLevel } = action;
  return {
    ...state,
    header: {
      ...state.header,
      approvalTypeLevelId: approvalTypeLevel.approvalTypeLevelId,
      approvalTypeId: approvalTypeLevel.approvalTypeId,
      siteId: approvalTypeLevel.siteId,
      orderId: approvalTypeLevel.orderId,
      levelName: approvalTypeLevel.levelName,
      defaultEmployeeName: approvalTypeLevel.defaultEmployeeName,
      isSystem: approvalTypeLevel.isSystem,
      changed: false
    },
    approvalTypeEmployees: approvalTypeLevel.approvalTypeEmployees.map(item => {
      return { ...item };
    }),
    approvalTypeUserGroups: approvalTypeLevel.approvalTypeUserGroups.map(item => {
      return { ...item };
    }),
    deletedItems: {
      approvalTypeEmployees: [],
      approvalTypeUserGroups: []
    }
  };
};

const onHeaderPropertyChanged = (state, action) => {
  const { propertyName, value } = action;
  return {
    ...state,
    header: {
      ...state.header,
      [propertyName]: value,
      changed: true
    }
  };
};

function setDefaultEmployee(state, action) {
  const { index, propertyValue } = action;
  const approvalTypeEmployees = [...state.approvalTypeEmployees];
  const localApprovalTypeEmployees = approvalTypeEmployees.map((employee, idx) => {
    var item = { ...employee };
    item.isDefault = idx === index ? propertyValue : false;
    return item;
  });

  return {
    ...state,
    header: { ...state.header, changed: true },
    approvalTypeEmployees: localApprovalTypeEmployees
  };
}

function setDefaultUserGroup(state, action) {
  const { index, propertyValue } = action;
  const approvalTypeUserGroups = [...state.approvalTypeUserGroups];
  const localApprovalTypeLevelGroups = approvalTypeUserGroups.map((userGroup, idx) => {
    var item = { ...userGroup };
    item.isDefault = idx === index ? propertyValue : false;
    return item;
  });

  return {
    ...state,
    header: { ...state.header, changed: true },
    approvalTypeUserGroups: localApprovalTypeLevelGroups
  };
}

function onPropertyChanged(state, action) {
  const { index, collection, propertyValue, propertyName } = action;

  return {
    ...state,
    header: { ...state.header, changed: true },
    [collection]: Object.assign([...state[collection]], {
      [index]: {
        ...state[collection][index],
        [propertyName]: propertyValue
      }
    })
  };
}
function onApprovalTypeLevelAdded(state, action) {
  return {
    ...state,
    header: {
      ...state.header,
      approvalTypeLevelId: null,
      approvalTypeId: action.approvalTypeId,
      siteId: action.siteId,
      orderId: null,
      levelName: '',
      defaultEmployeeName: null,
      isSystem: false,
      changed: false
    },
    approvalTypeEmployees: [],
    approvalTypeUserGroups: []
  };
}
function onAddApprovalTypeEmployee(state, action) {
  const { collection } = action;

  const item = {
    approvalTypeEmployeeId: null,
    approvalTypeLevelId: state.header.approvalTypeLevelId,
    approvalTypeId: state.header.approvalTypeId,
    siteId: state.header.siteId,
    employeeId: null,
    isDefault: false
  };
  const newCollection = Object.assign([...state[collection]]);
  newCollection.push({ ...item });

  return {
    ...state,
    header: { ...state.header, changed: true },
    [collection]: newCollection
  };
}

function onAddApprovalTypeUserGroup(state, action) {
  const { key, collection } = action;

  const item = {
    approvalTypeLevelId: state.header.approvalTypeLevelId,
    approvalTypeId: state.header.approvalTypeId,
    siteId: state.header.siteId,
    userGroupId: null,
    isDefault: false
  };
  const newCollection = Object.assign([...state[collection]]);
  newCollection.push({ ...item, [key]: null });

  return {
    ...state,
    header: { ...state.header, changed: true },
    [collection]: newCollection
  };
}

function onDeleteItemCollection(state, action) {
  const { collection, key, index } = action;
  const newCollection = Object.assign([...state[collection]]);
  const removedItem = state[collection][index];
  const deletedItems = [...state.deletedItems[collection]];
  newCollection.splice(index, 1);
  if (key || key === 0) deletedItems.push(removedItem);
  return {
    ...state,
    header: { ...state.header, changed: true },
    [collection]: newCollection,
    deletedItems: { ...state.deletedItems, [collection]: [...deletedItems] }
  };
}

function onApprovalTypeLevelSaved(state) {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false
    }
  };
}
